import { render, staticRenderFns } from "./PrivacyPolicyBox.vue?vue&type=template&id=3641da87&scoped=true"
import script from "./PrivacyPolicyBox.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyBox.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyBox.vue?vue&type=style&index=0&id=3641da87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641da87",
  null
  
)

export default component.exports